jQuery($ => {
    // if ($(".m-modal-trigger__trigger")[0]) {
    //     $(".m-modal-trigger__trigger").mousedown(function () {
    //         const modalId = $(this).attr("aria-controls");

    //         $(this).toggleClass('m-modal-trigger__trigger--active');
    //         toggleModal(this, modalId, true);
    //     });

    //     $(".m-modal-trigger__trigger").keydown(function (e) {
    //         if (e.key === 'Enter' || e.key === 'spacebar' || e.key === ' ') {
    //             e.preventDefault();

    //             const modalId = $(this).attr("aria-controls");

    //             $(this).addClass('m-modal-trigger__trigger--active');
    //             openModal(modalId, false, this, true);
    //         }
    //     });
    // }
});